import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, Grid, Button, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Select, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import { setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import RemarkListPage from "components/remark/page/RemarkListPage";
import { setitemIdBeingComment } from "store/slice/AppSlice";
import CommentMgmt from "./comment/CommentMgmt";
import { initRefreshCommentList,setEnableAddComment } from "store/slice/AppSlice";
import FieldView2 from "core/components/layout/FieldView2";
import { updateProductInfo } from "components/product/ProductAPI";
import { updateProductObj } from 'store/slice/PharmaSlice';
import {getListAPI as getAssetList} from "components/pharmaset/PharmasetAPI"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


export default function TaskSpaceProdUpdateSetAndColor() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse } = useSelector((state) => state.appslice.wkflow);
  const {remarkList} = useSelector((state) => state.pharmaslice);
  const {taskConfirmationMsg} = useSelector((state) => state.appslice.wkflow);
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedTaskObj, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const [canComplete,setCanComplete] = useState(false);

  const [setNameDialogOpen, setSetNameDialogOpen] = useState(false);
  const [setNameInput, setSetNameInput] = useState(productObj.setname || "");

  // Add these states for color editing
  const [colorDialogOpen, setColorDialogOpen] = useState(false);
  const [colorInput, setColorInput] = useState(productObj.liquidcolor || "");
  const [setList, setSetList] = useState([]);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [setNameFilter, setSetNameFilter] = useState("");
  const [filteredSetList, setFilteredSetList] = useState([]);

  // Update filteredSetList whenever setList or setNameFilter changes
  useEffect(() => {
    console.log("setNameFilter changed:", setNameFilter);
    setFilteredSetList(
      setList.filter(item=>item.formid===productObj.formid).
      filter(item =>
        (item.title || "")
          .toLowerCase()
          .includes(setNameFilter.trim().toLowerCase())
      )
    );
  }, [setList, setNameFilter]);

  useEffect(() => {
    getListAPI(setPmorderList, () => { });
    getAssetList(setSetList, () => { });
  }, []);
  useEffect(() => {
    if (confirmed) {
      dispatch(setReferbackTaskButtonEnabled(false));
      dispatch(setCompleteTaskButtonEnabled(true));
    } else {
      dispatch(setReferbackTaskButtonEnabled(true));
      dispatch(setCompleteTaskButtonEnabled(false));
    }
  },[confirmed]);

  useEffect(() => {
    // if (productObj.formname === "Tablet" || productObj.formname === "Capsule" || productObj.formname === "Capsul" || productObj.formname === "Sachet") {
    //   if (productObj.setname && productObj.liquidcolor)
    //     dispatch(setCompleteTaskButtonEnabled(true));
    //   else
    //     dispatch(setCompleteTaskButtonEnabled(false));
    
    // } 
    // else { // NON Tablet/Capsule/Sachet forms
    //     if (productObj.formname === "Mouth Wash" || productObj.formname === "Syrup") {
    //       if (productObj.liquidcolor)
    //         dispatch(setCompleteTaskButtonEnabled(true));
    //       else
    //         dispatch(setCompleteTaskButtonEnabled(false));
    //   }
    // }
    dispatch(setCompleteTaskButtonEnabled(false));
    dispatch(setReferbackTaskButtonEnabled(true));
   }, [productObj]);
  useEffect(() => {
    if (taskApiResponse && taskApiResponse.success !== undefined) {
      dispatch(initRefreshCommentList());
      dispatch(setEnableAddComment(false));
    }
  },[taskApiResponse]);

  const handleSetNameEditOpen = () => {
    setSetNameInput(productObj.setname || "");
    setSetNameDialogOpen(true);
  };

  const handleSetNameEditSave = () => {
    setSetNameDialogOpen(false);
    updateProductInfo(productObj.id, { setname: setNameInput }, (response) => {
      dispatch(updateProductObj(response));
    }, (error) => {
      console.log("Error updating set name:", error);
    });
  };

  const handleSetNameEditCancel = () => {
    setSetNameDialogOpen(false);
  };

  // Handler to open color dialog
  const handleColorEditOpen = () => {
    setColorInput(productObj.liquidcolor || "");
    setColorDialogOpen(true);
  };

  // Handler to save color
  const handleColorEditSave = () => {
    setColorDialogOpen(false);
    updateProductInfo(productObj.id, { liquidcolor: colorInput }, (response) => {
      dispatch(updateProductObj(response));
    }, (error) => {
      console.log("Error updating color:", error);
    });
  };

  // Handler to cancel color edit
  const handleColorEditCancel = () => {
    setColorDialogOpen(false);
  };

  return (
   <Grid container sx={{ width: '100%', }}>
         <Grid item lg={4} md={4} sm={12} xs={12}>
           <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
             <Tabs
               value={tabIndex}
               onChange={(_, v) => setTabIndex(v)}
               variant="fullWidth"
               sx={{ borderBottom: 1, borderColor: 'divider' }}
             >
               <Tab label="Product Info" />
               <Tab label="Comments" />
             </Tabs>
             <Box sx={{}}>
               {tabIndex === 0 && (
                 <ProductInfo maxHeight="70vh" />
               )}
               {tabIndex === 1 && (
                 <Box sx={{ p: 2, minHeight: '70vh' }}>
                   <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                     <CommentMgmt maxHeight="60vh" status={1} />
                   </Box>
                 </Box>
               )}
             </Box>
           </Box>
         </Grid>
         <Grid item lg={4} md={8} sm={12} xs={12}>
                 <Grid container direction="row" sx={{ width: '100%' }}>
                   <Grid item lg={12} sx={{ p: 1 }}>
                     <Grid container direction="column" sx={{ width: '100%', }}>
                       <Grid item lg={12} sx={{}}>
                         <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                           <Grid container justifyContent="space-between" sx={{}}>
                                             <Grid item lg={6}>
                                               <Typography variant="h6" sx={{ color: 'primary.darker', }}>Product Design </Typography>
                                             </Grid>
         
                                             
                           </Grid>
                           <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", mt: 1 }}>
                             {!productObj.assetpath ? (
                               <CloudUploadIcon
                                 sx={{ fontSize: 80, color: "#bdbdbd", mb: 2 }}
                               />
                             ) : (
                               <img
                                 src={productObj.assetpath}
                                 alt="Product Asset"
                                 style={{ borderRadius: 8, marginBottom: 16, cursor: "pointer" }}
                                 width="1024px"
                                 height="500px"
                                 onClick={() => setImageDialogOpen(true)}
                               />
                             )}
                             {/* Checkbox for confirmation below image */}
                             
                           </Box>
                           
                         </Box>
                         <Box sx={{ mt: 2, ml:2 }}>
                            <FormControlLabel
                               control={
                                 <input
                                   type="checkbox"
                                   checked={confirmed}
                                   onChange={e => setConfirmed(e.target.checked)}
                                   style={{ accentColor: '#1976d2', width: 20, height: 20 }}
                                 />
                               }
                               label={<span style={{ fontSize: 16 }}>I confirm that Design is correct as per Product need</span>}
                               sx={{  }}
                             />
                            </Box>
                       </Grid>
                     </Grid>
                   </Grid>
                 </Grid>
                 
               </Grid>
         {/* <Grid item lg={4} md={4} sm={12} xs={12}>
           <Grid container direction="row" sx={{ width: '100%' }}>
             <Grid item lg={12} sx={{ p: 1 }}>
               <Grid container direction="column" sx={{ width: '100%', }}>
                {(
                  productObj.formname === "Tablet" || 
                  productObj.formname === "Capsul" || 
                  productObj.formname === "Capsule" || 
                  productObj.formname === "Sachet" 
                  // ||
                  // productObj.formname === "Syrup" ||
                  // productObj.formname === "Liquid" ||
                  // productObj.formname === "Mouth Wash" 
                
                
                ) && (
                 <Grid item lg={12} sx={{}}>
                   <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                     <Grid container justifyContent="space-between" sx={{}}>
                            <Grid container alignItems="center" justifyContent="space-between">
                              <Grid item>
                                <FieldView2 label="Set Name" value={productObj.setname || "-"} />
                              </Grid>
                              <Grid item>
                                <Button
                                  size="small"
                                  onClick={handleSetNameEditOpen}
                                  sx={{
                                    minWidth: 0,
                                    background: '#f5f5f5',
                                    borderRadius: '50%',
                                    p: 1,
                                    ml: 2,
                                  }}
                                  aria-label="Edit Set Name"
                                  disabled={taskApiResponse}
                                >
                                  <EditIcon fontSize="small" />
                                </Button>
                              </Grid>
                            </Grid>
                     </Grid>
                   </Box>
                 </Grid>
                )}
                 <Grid item lg={12} sx={{mt:2}}>
                {(
                  productObj.formname === "Tablet" || 
                  productObj.formname === "Capsul" || 
                  productObj.formname === "Capsule" || 
                  productObj.formname === "Sachet"|| 
                  productObj.formname === "Syrup"||
                  productObj.formname === "Syrup" ||
                  productObj.formname === "Liquid" ||
                  productObj.formname === "Mouth Wash" 
                
                ) && (
                   
                      <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                        <Grid container justifyContent="space-between" sx={{}}>
                                <Grid container alignItems="center" justifyContent="space-between">
                                  <Grid item>
                                    <FieldView2 label="Color" value={productObj.liquidcolor || "-"} />
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      size="small"
                                      onClick={handleColorEditOpen}
                                      sx={{
                                        minWidth: 0,
                                        background: '#f5f5f5',
                                        borderRadius: '50%',
                                        p: 1,
                                        ml: 2,
                                      }}
                                      aria-label="Edit Color"
                                      disabled={taskApiResponse}
                                    >
                                      <EditIcon fontSize="small" />
                                    </Button>
                                  </Grid>
                                </Grid>
                        </Grid>
                      </Box>
                   
                )}
                 </Grid>
               </Grid>
             </Grid>
           </Grid>
           
         </Grid> */}
         <Dialog
  open={setNameDialogOpen}
  onClose={handleSetNameEditCancel}
  PaperProps={{
    sx: { width: { xs: '90vw', lg:'50vw', md: '50vw', sm: '90vw' } }
  }}
>
  <DialogTitle>Edit Set Name</DialogTitle>
  <DialogContent>
    <TextField
      autoFocus
      fullWidth
      margin="dense"
      label="Filter Set Name"
      value={setNameFilter}
      onChange={e => setSetNameFilter(e.target.value)}
      variant="outlined"
      sx={{ mb: 2 }}
    />
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        maxHeight: '55vh',
        minHeight: '200px',
        overflowY: 'auto',
        minWidth: '200px',
        p: 0,
        background: '#fafafa'
      }}
    >
{
  filteredSetList.length === 0 ? (
    <Typography sx={{ p: 2, color: 'text.secondary', textAlign: 'center' }}>
      No items as per given filter
    </Typography>
  ) : (
      filteredSetList.map((item) => {
          const value = item.title || "";
          const isSelected = setNameInput === value;
          return (
            <Typography variant="h6"
             sx={{p:1, borderBottom: '1px solid #e0e0e0', background: isSelected ? '#c8e6c9' : 'transparent', cursor: 'pointer' }}
            onClick={() => setSetNameInput(value)}
            >
              {value}
            </Typography>
          );
        })
      )
}
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleSetNameEditCancel} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleSetNameEditSave}
      color="primary"
      disabled={!setNameInput.trim()}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>
<Dialog
  open={colorDialogOpen}
  onClose={handleColorEditCancel}
  PaperProps={{
    sx: { width: 300 }
  }}
>
  <DialogTitle>Edit Color</DialogTitle>
  <DialogContent>
    <TextField
      autoFocus
      margin="dense"
      label="Color"
      type="text"
      fullWidth
      variant="outlined"
      value={colorInput}
      onChange={(e) => setColorInput(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={handleColorEditCancel} color="primary">
      Cancel
    </Button>
    <Button
      onClick={handleColorEditSave}
      color="primary"
      disabled={!colorInput.trim()}
    >
      Save
    </Button>
  </DialogActions>
</Dialog>
<Dialog
  open={imageDialogOpen}
  onClose={() => setImageDialogOpen(false)}
  fullScreen
  PaperProps={{
    sx: { background: 'rgba(0,0,0,0.95)' }
  }}
>
  <IconButton
    aria-label="close"
    onClick={() => setImageDialogOpen(false)}
    sx={{
      position: 'absolute',
      right: 16,
      top: 16,
      color: '#fff',
      zIndex: 10
    }}
  >
    <CloseIcon />
  </IconButton>
  <Box
    sx={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <img
      src={productObj.assetpath}
      alt="Product Asset"
      style={{
        maxWidth: '100vw',
        maxHeight: '100vh',
        objectFit: 'contain'
      }}
    />
  </Box>
</Dialog>
       </Grid>
  );
}